$(() => {
    const $hotJobsFirstTitle = $('[data-selector="hot-jobs-first-title"]');
    const $hotJobsFirstContent = $('[data-selector="hot-jobs-first-content"]');

    $hotJobsFirstTitle.on('mouseenter', function callback() {
        // title激活
        $hotJobsFirstTitle.removeClass('hot-jobs-first-title-active');
        $(this).addClass('hot-jobs-first-title-active');
        // 内容区激活
        $hotJobsFirstContent.removeClass('hot-jobs-first-content-active')
        $(this).next().addClass('hot-jobs-first-content-active');
    })
});

